'use client'

import { ComponentProps, useContext } from 'react'

import { OfferRequestMessage as BaseOfferRequestMessage } from '@marketplace-web/offers/price-offers-feature'
import {
  ConversationListContext,
  useConversationContext,
  useTransactionActions,
} from '@marketplace-web/messaging/conversation-providers-feature'

import { isDateInTheFuture } from '../../../utils/date'

type Props = Pick<
  ComponentProps<typeof BaseOfferRequestMessage>,
  'message' | 'isGrouped' | 'createdTime' | 'entityType'
>

const OfferRequestMessageWithConversationContext = (props: Props) => {
  const { conversation, transaction, getConversationRequest } = useConversationContext()
  const { updateConversation } = useContext(ConversationListContext)
  const { applicableTransactionActions } = useTransactionActions()

  if (!conversation) return null
  if (!conversation.oppositeUser) return null
  if (!conversation.transactionId) return null

  return (
    <BaseOfferRequestMessage
      {...props}
      transactionId={conversation.transactionId}
      oppositeUser={conversation.oppositeUser}
      offerPrice={transaction?.offer.price}
      applicableTransactionActions={applicableTransactionActions}
      isPaymentActionAvailable={conversation.isPaymentActionAvailable}
      isSellerCountdownActive={Boolean(
        isDateInTheFuture(transaction?.seller?.closetCountdownEndDate),
      )}
      buyerId={conversation.buyerId}
      onActionClick={() => {
        getConversationRequest({ conversationId: conversation.id })

        updateConversation({ id: conversation.id })
      }}
    />
  )
}

export default OfferRequestMessageWithConversationContext
